import { setContext, getContext } from 'svelte';
import { writable } from 'svelte/store';
import { getUrl } from './urlUtils.js';
// Create a store to keep track of logged in state.
export function initLoggedIn(state = false) {
    const loggedIn = writable(state);
    setContext('LOGGED_IN', loggedIn);
    return loggedIn;
}
// Get the logged in state.
// Default to false to test isolated components.
export function getLoggedIn() {
    return getContext('LOGGED_IN') || writable(false);
}
// Create a store to keep track of current navigation
// category, subcategory, and drawer state.
export function initNavState(state = {}) {
    const navState = writable(state);
    setContext('NAV_STATE', navState);
    return navState;
}
// Get the navigation state object.
// Default to {} to test isolated components.
export function getNavState() {
    return getContext('NAV_STATE') || writable({});
}
// Create a store to keep track of cart item count.
export function initCartCount(count = 0) {
    const cartCount = writable(count);
    setContext('CART_COUNT', cartCount);
    return cartCount;
}
// Get the cart count.
// Default to 0 to test isolated components.
export function getCartCount() {
    return getContext('CART_COUNT') || writable(0);
}
// Create a store to keep track of
// the mobile drawer top position.
export function initDrawerTop(pos = 0) {
    const drawerTop = writable(pos);
    setContext('DRAWER_TOP', drawerTop);
    return drawerTop;
}
// Get the drawer top value.
// Default to 0 to test isolated components.
export function getDrawerTop() {
    return getContext('DRAWER_TOP') || writable(0);
}
// Create a store to keep track of the current URL.
export function initCurrentUrl(url) {
    const currentUrl = writable(url || getUrl());
    setContext('CURRENT_URL', currentUrl);
    return currentUrl;
}
// Get the current URL store.
export function getCurrentUrl() {
    return getContext('CURRENT_URL') || writable(getUrl());
}
export const subcategoryHeight = writable(0);
// Create a store to keep track of top-level Category open states.
export const categoryOpenStates = writable(new Map());
// Create a store to keep track of feature flags.
export const flagsStore = writable(new Map());
// Function to update flagsStore
export function setFlags(flags) {
    if (!flags) {
        return;
    }
    try {
        flagsStore.set(new Map(Object.entries(JSON.parse(flags))));
    }
    catch (e) {
        console.error('Error parsing flags', e);
    }
}
// FlattenNavState flattens the nav state
export function initFlattenedNavRenderState(state) {
    const flattenedNavRenderState = writable(state);
    setContext('FLATTENED_NAV_RENDER_STATE', flattenedNavRenderState);
    return flattenedNavRenderState;
}
export function getFlattenedNavRenderState() {
    return getContext('FLATTENED_NAV_RENDER_STATE') || writable(false);
}
export function setAccessibilityRedesignRenderState(state) {
    const accessibilityRedesignRenderState = writable(state);
    setContext('ACCESSIBILITY_REDESIGN_RENDER_STATE', accessibilityRedesignRenderState);
    return accessibilityRedesignRenderState;
}
export function getAccessibilityRedesignRenderState() {
    return getContext('ACCESSIBILITY_REDESIGN_RENDER_STATE') || writable(false);
}
